import { API } from "../../Services";
import customers from "../../Services/Apis/customers";

export const transectionList = (query='') =>{
    return (dispatch) =>{
        dispatch({
            type:"FETCH_TRANSECTION_LIST",
        })
    
        API.transectionList(query).then((res)=>{
            console.log(res);
            let data = JSON.parse(JSON.stringify(res)).data.transactions
          
            setTimeout(()=>{
                dispatch({
                    type:"RECEIVE_TRANSECTION_LIST",
                    payload:{data:data,totalRecords:res.data.totalTransaction},
                })
            },1000)
        }).catch((err)=>{
            dispatch({
                type:"ERROR_TRANSECTION_LIST",
            })
        })
    }
}

